import { IconError, IconLock, IconProps } from "@powerledger/ui-component-lib";
import { FC } from "react";

export const companyDetailsStatusIconMap: Record<string, FC<IconProps>> = {
  Error: IconError,
  Lock: IconLock,
};
